import SchemaForm from './schema-form.vue';
import SchemaFormItem from './schema-form-item.vue';
import type { DefineComponent } from 'vue';
import type { SchemaFormProps } from './schema-form';

export * from './types';
export * from './schema-form';
export * from './schema-form-item';
export * from './hooks';
export * from './components';

export { SchemaForm, SchemaFormItem };

// TODO 暂时是为了解决ts error(如果你有解决方法 请务必联系我~): JSX element type 'SchemaForm' does not have any construct or call signatures.
export default SchemaForm as unknown as DefineComponent<Partial<SchemaFormProps>>;
